module.exports = __webpack_public_path__ + "static/img/Rui_ZHU.cffef53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/Rui_ZHU.png
// module id = TAop
// module chunks = 1